import Vue from 'vue'
import App from './App.vue'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import vuetify from './plugins/vuetify'
import router from './router.js'
import VueAutosuggest from "vue-autosuggest"
import vueHeadful from 'vue-headful' // Muda o Title da página

Vue.component('vue-headful', vueHeadful);
Vue.use(VueAutosuggest);

Vue.config.productionTip = false

new Vue({
  vuetify,
  theme: {
    primary: 'red',
  },
  router,
  render: h => h(App)
}).$mount('#app')
